interface BlockParams {
  viewerCanBlockFromOrg: boolean
  hasAuthor: boolean
  isAuthorCopilot: boolean
}

interface UnblockParams {
  viewerCanUnblockFromOrg: boolean
  hasAuthor: boolean
}

interface PersonalBlockParams {
  viewerCanBlockPersonally: boolean | undefined
  hasAuthor: boolean
  isAuthorCopilot: boolean
}

interface PersonalUnblockParams {
  viewerCanUnblockPersonally: boolean | undefined
  hasAuthor: boolean
}

export function canBlock(params: BlockParams) {
  const {viewerCanBlockFromOrg, hasAuthor, isAuthorCopilot} = params

  if (!hasAuthor) {
    // Basic requirement for blocking is that there is an author
    return false
  }
  if (isAuthorCopilot) {
    // Cannot block Copilot users
    return false
  }
  return viewerCanBlockFromOrg
}

export function canUnblock(params: UnblockParams) {
  const {viewerCanUnblockFromOrg, hasAuthor} = params

  if (!hasAuthor) {
    // Basic requirement for unblocking is that there is an author
    return false
  }
  return viewerCanUnblockFromOrg
}

export function canBlockPersonally(params: PersonalBlockParams) {
  const {viewerCanBlockPersonally, hasAuthor, isAuthorCopilot} = params

  if (!hasAuthor) return false
  if (isAuthorCopilot) return false
  return viewerCanBlockPersonally
}

export function canUnblockPersonally(params: PersonalUnblockParams) {
  const {viewerCanUnblockPersonally, hasAuthor} = params

  if (!hasAuthor) return false
  return viewerCanUnblockPersonally
}
